import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { RequestStrikeInterface } from 'src/app/util/interfaces/request';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CustomerStrikeService {
	private getStrikeUrl = environment.baseApiUrl + 'request/strike';
	private putStrikeClientUrl = environment.baseApiUrl + 'request/strikeClient/{idCustomer}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getStrikeCustomer(request_id?: string): Observable<RequestStrikeInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getStrikeUrl = this.getStrikeUrl;
		if (request_id) {
			getStrikeUrl = `${getStrikeUrl}?request_id=${request_id}`;
		}

		return this.http.get<RequestStrikeInterface[]>(getStrikeUrl, { headers: headers });
	}

	updateStrikeClient(idCustomer: string, formUpdate: RequestStrikeInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putStrikeClientUrl = this.putStrikeClientUrl.replace('{idCustomer}', idCustomer);
		const body = {
			enable_3strikes: formUpdate.enable_3strikes,
			strikes_interval: formUpdate.strikes_interval,
			strikes_attempt: formUpdate.strikes_attempt,
		};

		return this.http.put<JSON>(putStrikeClientUrl, body, { headers: headers });
	}
}
